import { DisclosuresRowFormComponent } from './disclosures-row-form.component';
import { DisclosuresRowPreviewComponent } from './disclosures-row-preview.component';
import { CSSProperties, useEffect, useState } from 'react';
import { IDataRequest } from '@vivli/features/data-requests/infrastructure/interface';
import { useCitationsContext } from '@vivli/shared/features/citations/infrastructure/context';
import { ICitation } from '@vivli/shared/features/citations/infrastructure/interface';
import { Color, Size } from '@vivli/shared/theme';

const paragraphContainerStyle: CSSProperties = {
    display: 'grid',
    gridAutoFlow: 'row',
    paddingBottom: 0,
    paddingTop: Size.INSET_SIZE / 2.8,
    color: Color.VIVLI_PUBLISHED_DARKBLUE,
    whiteSpace: 'pre-wrap',
    lineHeight: '1.25',
};

const paragraphHeaderStyle: CSSProperties = {
    fontWeight: 'bold',
    marginRight: '10px',
    marginBottom: Size.INSET_SIZE / 3,
};

const listSectionStyle: CSSProperties = {
    ...paragraphContainerStyle,
    marginLeft: '0',
};

const disclosureListStyle: CSSProperties = {
    display: 'grid',
    gridAutoFlow: 'column',
    gridTemplateColumns: '24px 1fr',
    marginBottom: -20,
};

interface DisclosuresListProps {
    fieldsDisclosures: any[];
    dataRequest: IDataRequest;
    isConfigMode: boolean;
    arrayName: string;
}

export const DisclosuresListComponent = ({ dataRequest, isConfigMode, fieldsDisclosures, arrayName }: DisclosuresListProps) => {
    const { citations } = useCitationsContext();
    const [disclosures, setDisclosures] = useState<{ citation: ICitation; fieldName: string }[]>();

    useEffect(() => {
        if (!fieldsDisclosures || !citations?.length) {
            return;
        }

        const disclosures = fieldsDisclosures
            .map(({ citationReferenceId }, index) => {
                const citation = citations?.find((c) => c.id === citationReferenceId);
                const fieldName = `${arrayName}.${index}.`;

                return {
                    citation,
                    fieldName,
                };
            })
            .filter((x) => x.citation);

        setDisclosures(disclosures);
    }, [fieldsDisclosures, citations]);

    return (
        <div style={{ ...paragraphContainerStyle, marginBottom: 0 }}>
            <div style={paragraphContainerStyle}>
                <span style={paragraphHeaderStyle}>Public Disclosures:</span>
            </div>
            <div style={{ ...listSectionStyle, marginBottom: -20 }}>
                {isConfigMode &&
                    disclosures?.map(({ citation, fieldName }, index) => (
                        <DisclosuresRowFormComponent
                            key={fieldName}
                            index={index}
                            citation={citation}
                            fieldName={fieldName}
                            isConfigMode={true}
                        />
                    ))}
                <div>
                    {!isConfigMode &&
                        dataRequest?.publishing?.publishingRules.citationPublishingRules
                            .filter((x) => x.publishable)
                            ?.map((c, index) => (
                                <div key={index}>
                                    <span style={disclosureListStyle}>
                                        {index + 1}
                                        {') '}
                                        <DisclosuresRowPreviewComponent citationToShow={c} index={index} isConfigMode={false} />
                                    </span>
                                </div>
                            ))}
                </div>
            </div>
        </div>
    );
};
